import { useEffect } from "react";
/**
 * Custom hook to automatically mask all iframes with data-clarity-mask="true"
 * This prevents Microsoft Clarity from attempting to serialize iframe elements,
 * which causes DataCloneError exceptions.
 */
const useMaskIframes = () => {
  useEffect(() => {
    // Mask all existing iframes on mount
    const maskExistingIframes = () => {
      document.querySelectorAll("iframe").forEach((iframe) => {
        if (!iframe.hasAttribute("data-clarity-mask")) {
          iframe.setAttribute("data-clarity-mask", "True");
        }
      });
    };
    maskExistingIframes();
    // Watch for dynamically added iframes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeName === "IFRAME") {
            (node as HTMLIFrameElement).setAttribute("data-clarity-mask", "True");
          } else if ((node as Element).querySelectorAll) {
            (node as Element).querySelectorAll("iframe").forEach((iframe) => {
              if (!iframe.hasAttribute("data-clarity-mask")) {
                iframe.setAttribute("data-clarity-mask", "True");
              }
            });
          }
        });
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    // Cleanup
    // eslint-disable-next-line consistent-return
    return () => {
      observer.disconnect();
    };
  }, []);
};

export default useMaskIframes;
